var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 625 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 625,
    height: 400,
    fill: "#032ea1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 625,
    height: 200,
    y: 100,
    fill: "#e00025"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.96,
    transform: "translate(117.14286,-434.9336)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m139.02,623.46,113.8,0,0,43.788-113.8,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 246.95,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 113.8,
    height: 5.0903,
    x: 139.02,
    y: 639.49
  }), /*#__PURE__*/React.createElement("rect", {
    width: 113.8,
    height: 4.489,
    x: 139.02,
    y: 632.59
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0.94545,
    width: 113.8,
    height: 4.354,
    x: 139.02,
    y: 625.7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 168.98,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 217.97,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 139.92,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 146.95,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 154.45,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 161.95,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 224.77,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 232.27,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5864,
    height: 16.495,
    x: 239.77,
    y: 647.64
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    d: "m94.509,669.55c1.7604-0.89672,3.7684-2.9836,4.425-5.319h193.07c0.65665,2.3354,2.6647,4.4222,4.425,5.319z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m193,556.8s-0.14437-4.1125,2.2507-4.1572c2.3951,0.0447,2.2507,4.1572,2.2507,4.1572z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.51,611.34,0-5.5357c-0.0789-2.768-2.7591-2.9681-2.838-4.9862,0,0-0.34606-3.0266,0.45159-4.4082,1.0845,4.0474,3.0561,3.3039,3.0561,1.6397,0-1.4526-1.117-2.8031-3.408-6.3302-0.73206-1.127-0.27901-4.6597,0.74692-5.9224,0.39808,3.0709,0.85311,4.5398,2.1717,4.5398,0.80428,0,1.4612-0.52417,1.4612-2.0621,0-1.9565-1.325-2.9445-1.9762-4.725-0.76004-2.0777-0.23675-4.1957,1.0259-5.3795,0.54129,3.0293,0.38028,4.2372,1.7255,4.2372,2.7133-0.8584,0.00063-4.7866-0.57911-5.7773-0.667-1.1553,0.89682-3.4598,0.89682-3.4598,0.86209,2.6898,1.1394,2.909,2.0699,2.6597,1.1738-0.31452,1.0224-2.056-0.40996-3.4633-0.90449-0.88866-0.80857-2.2116,0.16248-3.274,0.97489,1.9056,2.2229,1.7898,2.343,0.65821l-0.78373-4.3931h17.255l-0.85683,4.2488c-0.24526,1.2162,1.396,1.4801,2.4162-0.51392,0.97105,1.0624,1.067,2.3854,0.16248,3.274-1.4323,1.4073-1.5837,3.1488-0.40996,3.4633,0.93041,0.2493,1.2078,0.0302,2.0699-2.6597,0,0,1.403,1.5708,0.89682,3.4598-0.57974,0.99071-3.2924,4.9189-0.57911,5.7773,1.3453,0,1.1842-1.2079,1.7255-4.2372,1.2627,1.1838,1.786,3.3017,1.0259,5.3795-0.65127,1.7804-1.9762,2.7685-1.9762,4.725,0,1.538,0.65688,2.0621,1.4612,2.0621,1.3186,0,1.7736-1.4689,2.1717-4.5398,1.0259,1.2627,1.479,4.7953,0.74692,5.9224-2.291,3.527-3.408,4.8776-3.408,6.3302,0,1.6641,1.9716,2.4076,3.0561-1.6397,0.79765,1.3816,0.4516,4.4082,0.4516,4.4082-0.0789,2.018-2.7591,2.2182-2.838,4.9862v5.5357z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.73,565.32-0.39721-3.125,15.838,0-0.39721,3.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.79,562.13-0.34117-2.5686,13.604,0-0.34117,2.5686z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.95,559.47-0.22717-2.5686,9.0585,0-0.22718,2.5686z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.97,669.55c-2.0266-0.78125-4.9773-2.9188-4.9773-5.0695v-24.297l2.6385-3.3588-52.776,0.00008,2.5293,3.3588v24.297c0,2.1508-2.0264,4.2883-4.0529,5.0695z"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeLinejoin: "bevel",
    width: 3.5864,
    height: 16.495,
    x: 178.24,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    strokeLinejoin: "bevel",
    width: 3.5864,
    height: 16.495,
    x: 208.56,
    y: 647.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.91,609.17,0,14.648,0,7.0117,0,5.9961,54.023,0,0-5.957,0.0783-21.699c-2.2097,0.8681-2.5976,2.8711-2.5976,2.8711v11.777h-48.75v-11.777s-0.5442-2.003-2.7539-2.8711z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.6,669.55c-1.7655-0.78125-5.6118-2.9188-5.6118-5.0695v-27.192c0.37751-1.518,2.436-2.414,3.761-3.3588h-35.823c1.7049,0.90271,3.6054,1.6522,4.2846,3.3588v27.192c0,2.1508-3.041,4.2883-4.8065,5.0695z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.41,634.22-0.00027-19.587-4.9104-0.00008,0-1.9085-38.839,0,0,1.9085-4.9109-0.00018,0.00017,19.587z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.86,669.55c-1.7299-0.78125-4.2489-2.9186-4.2489-5.0694v-23.215l1.4205-2.1088h-17.691l1.4205,2.109v23.215c0,2.1508-2.5189,4.2883-4.2488,5.0695z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.981,
    d: "m190.71,639.16,8.9655-0.00005,0,30.377-8.9655,0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "bevel",
    d: "m204.38,632.48c0.0215-2.0012,5.8375-2.091,8.8318-3.7949h-35.952c2.9943,1.7039,8.6755,1.8441,8.6755,3.7949l1.2166,3.8818,14.883,0.59776z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.41,611.34c0-4.8986,0.20532-6.7857,1.7103-6.7857l0.00001,15.58c-3.6912,1.3393-6.3254,6.0491-6.3254,6.0491l-23.211-0.00027s-2.6342-4.7096-6.3254-6.0488v-15.58c1.856,0,1.8682,1.9717,1.8682,6.7857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.12,609.33c0-5.6184,4.8512-6.2503,4.8512-6.2503v5c-1.8465-0.0789-2.7368,1.578-2.7368,4.0444,0,2.4663,1.4868,2.5056,1.4868,2.5056v14.19h-3.6012z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.28,609.33c0-5.6184-4.8512-6.2503-4.8512-6.2503v5c1.8465-0.0789,2.7368,1.578,2.7368,4.0444,0,2.4663-1.4868,2.5056-1.4868,2.5056v14.19h3.6012z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m186.84,570.62h17.128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.81,575.97h20.921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.78,582.46h24.904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.66,590.39h29.536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.98,599.43h30.426"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.96,
    d: "m170.75,628.92h48.661"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0.96,
    width: 18.036,
    height: 6.6291,
    x: 186.19,
    y: 628.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m183.93,614.24c2.9903,3.59,2.7128,9.6801,2.6786,13.27h17.343c-0.0342-3.59-0.31172-9.68,2.6786-13.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.68,573.11-2.3764-1.2239,0-3.4974c0.97149,0.29214,2.062,0.41142,2.1686,1.9595,0.33824-2.2099,0.94822-2.1018,1.9064-2.963,0.95814,0.86127,1.5681,0.75315,1.9064,2.963,0.10661-1.5481,1.1971-1.6674,2.1686-1.9595v3.4974l-2.3764,1.2239z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.52,578.85-3.9464-2.7128,0-3.2231c1.3836,0.32035,2.9366,0.45115,3.0885,2.1488,0.48172-2.4232,1.3504-3.6754,2.715-4.6198,1.3646,0.94444,2.2332,2.1966,2.715,4.6198,0.15183-1.6976,1.7049-1.8284,3.0885-2.1488v3.2231l-3.9464,2.7128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.24,587.8-4.5378-3.9854,0-4.7351c1.5909,0.47062,3.3767,0.66279,3.5513,3.1567,0.55391-3.56,1.5528-5.3995,3.1218-6.787,1.569,1.3875,2.5679,3.227,3.1218,6.787,0.17458-2.4939,1.9604-2.6861,3.5513-3.1567v4.7351l-4.5378,3.9854z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.61,593.09-4.1037,5.6759-4.6463,0-4.1037-5.6759z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.39,602.62c2.0526,1.1219,2.8106,3.3568,3.0299,7.5527h11.55c0.21927-4.1959,0.97728-6.4308,3.0298-7.5527z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "bevel",
    d: "m204.17,593.09,0-5.7018c-1.9498,0.53675-3.2129,1.6912-3.7755,3.2577,0-1.8927-2.4906-6.2573-5.2071-8.4294-2.7242,2.4314-5.2575,6.3801-5.2066,8.4294-0.46332-1.4918-1.8258-2.7209-3.7755-3.2577v5.702z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "bevel",
    d: "m205.04,602.62-0.00021-5.7022c-2.1373,0.53675-3.522,1.6912-4.1387,3.2577,0-1.8927-2.7299-6.2573-5.7077-8.4294-2.9863,2.4314-5.7635,6.3801-5.7077,8.4294-0.50788-1.4918-2.0014-2.7209-4.1387-3.2577v5.702z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "bevel",
    d: "m207.44,614.32,0-6.5765c-2.6591,0.68624-4.3124,2.653-5.1491,3.7996,0-3.5614-4.0212-8.9902-7.1011-10.768-3.1599,1.8244-7.1011,7.435-7.1011,10.768-0.85883-1.1395-2.49-3.1134-5.1491-3.7996v6.5765z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "bevel",
    d: "m206,628.92,0-6.7617c-2.3465,0.9193-3.0479,3.1802-3.7862,4.7163,0.28981-6.8584-3.8614-14.23-7.0239-16.1-3.1624,1.8699-7.3926,9.3996-7.0239,16.1-0.75787-1.5265-1.4397-3.797-3.7862-4.7163v6.7618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.36,639.16,0-6.7618c-2.4581,0.58449-2.61,1.491-3.3916,3.0055,0.28981-4.0963-2.6114-8.7695-5.7739-10.639-3.1624,1.8699-6.0637,6.5431-5.7739,10.639-0.78168-1.5145-0.87771-2.421-3.3916-3.0055v6.7618z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "tower"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m98.935,664.23,0-20.44c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-17.993l3.7418,2.0232,4.2712,18.811v22.965z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.935,664.31,0-20.519c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-19.243c2.5118,0,3.7418,3.2732,3.7418,3.2732l4.2712,18.811v22.886z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.275,669.55c1.7299-0.78125,4.2487-2.9188,4.2487-5.0695v-25.547l-1.1852-2.1088h43.522l-1.6983,2.1088v25.547c0,2.1508,1.7297,4.2883,3.4596,5.0695z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.84,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-24.297l3.619-3.359-29.588,0.00008,3.6191,3.3589v24.297c0,2.1508-2.5189,4.2883-4.2488,5.0695z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.69,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-21.965l2.369-3.359h-18.798l2.3688,3.359v21.965c0,2.1508-2.5189,4.2883-4.2488,5.0695z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.92,639.16,8.9819-0.00004-0.00002,30.393-8.9818,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeLinejoin: "bevel",
    width: 3.5864,
    height: 16.495,
    x: 103.7,
    y: 647.64
  }), /*#__PURE__*/React.createElement("rect", {
    strokeLinejoin: "bevel",
    width: 3.5864,
    height: 16.495,
    x: 134.45,
    y: 647.64
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "bevel",
    d: "m100.64,619.82h4.3202v16.909h-4.3202z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "bevel",
    d: "m100.64,616.64h4.2946v3.1387h-4.2946z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.0337,
    strokeLinejoin: "bevel",
    d: "m136.17,623.46h6.1594v13.054h-6.1594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.89,636.6,0-28.941c1.2321,0,1.4222,4.2418,4.249,4.2418,1.4716,0,1.3152-1.757,0.4889-3.1882-0.73168-1.2673-1.6372-3.0176-0.40702-6.2783,0.84298,2.4949,3.1119,3.2866,2.6927,1.722-0.72042-2.6886-2.7945-3.1298-1.2383-7.3021,0.54049,3.4806,2.7732,3.3273,2.2309,1.3034-0.61083-2.2796-1.8732-3.2139-0.3157-6.4275,0.87209,3.6492,2.0519,3.4352,2.0519,1.1711,0-3.347-0.1285-6.9568,4.2027-8.296,0,0,0.25002-3.0682,1.8123-3.0682s1.8123,3.0682,1.8123,3.0682c4.3312,1.3393,4.2027,4.949,4.2027,8.296,0,2.264,1.1798,2.4781,2.0519-1.1711,1.5574,3.2136,0.29513,4.1479-0.3157,6.4275-0.54227,2.0238,1.6904,2.1772,2.2309-1.3034,1.5562,4.1722-0.5179,4.6134-1.2383,7.3021-0.41923,1.5646,1.8497,0.77297,2.6927-1.722,1.2302,3.2606,0.32466,5.011-0.40702,6.2783-0.82627,1.4311-0.98274,3.1882,0.4889,3.1882,2.8268,0,3.0168-4.2418,4.249-4.2418v28.941z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.124,614.74,0.000081,22.079,2.5111,0-0.00019-22.135c-0.90498-0.45686-1.7546-0.5274-2.511,0.0558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.203,629.03c3.1124,1.5914,6.1949,3.4325,6.9754,7.7931h-6.9754z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.37,622.42,0.00006,14.407,2.0354,0,0-14.443c-0.63587-0.2981-1.5039-0.34413-2.0354,0.0364z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.41,628.92c-3.1124,1.5914-6.1949,3.4325-6.9754,7.7931h6.9754z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m122.83,595.27,1.8142-1.5247,0-1.9528c-0.6637,0.0645-1.0258,0.29275-1.516,0.93531-0.41694-1.2944-1.3337-2.3051-2.5624-2.9327-1.2287,0.6276-2.1454,1.5924-2.5624,2.8867-0.49022-0.64256-0.8523-0.8249-1.516-0.88935v1.9528l1.8142,1.5247z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.8,600.16,0.8432-1.8253,0-2.5384c-0.6637,0.0654-1.0258,0.29688-1.516,0.94855-0.41694-1.3127-1.3337-2.3377-2.5624-2.9742-1.2287,0.63649-2.1454,1.6149-2.5624,2.9276-0.49022-0.65166-0.8523-0.83658-1.516-0.90194v2.5384l0.8432,1.8253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.93,606.79,2.6948-3.2865,0-3.2432c-0.98588,0.11068-1.5237,0.50272-2.2519,1.6061-0.61934-2.2227-1.9811-2.7084-3.8062-3.7861-1.8251,1.0777-3.1869,1.4845-3.8062,3.7072-0.72818-1.1034-1.266-1.4165-2.2519-1.5272v3.2432l2.6949,3.2865z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.72,613.3s3.1405-2.7397,3.3269-4.2436v-3.4672c-1.2171,0.14291-2.3682,0.45834-3.2672,1.8831-0.76458-2.8701-1.9586-3.6704-4.2117-5.0621-2.2532,1.3916-3.4471,2.192-4.2117,5.0621-0.89895-1.4248-2.0501-1.7402-3.2672-1.8831v3.4672c0.3965,1.5039,3.3269,4.2436,3.3269,4.2436z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.06,625.32s4.3013-4.7614,4.3999-6.6164v-5.4059c-1.6097,0.22281-3.1321,1.3298-4.321,3.5513-1.0112-4.4748-2.5903-7.5949-5.5702-9.7647-2.9799,2.1698-4.559,5.2898-5.5702,9.7647-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.30884,1.8551,4.3999,6.6164,4.3999,6.6164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.06,632.43s3.6763-3.7418,4.3999-5.3664v-5.4059c-1.6097,0.22281-3.1321,1.3299-4.321,3.5513-1.0112-4.4748-2.5903-7.0369-5.5702-9.2067-2.9799,2.1698-4.559,4.7318-5.5702,9.2067-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.93384,1.6247,4.3999,5.3664,4.3999,5.3664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.54,636.56c-1.0733-4.6678-1.9959-8.1303-7.163-11.641-5.167,3.5104-6.0894,6.9728-7.1627,11.641z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.2,639.16,0-6.7618c-2.3465,0.91931-4.467,2.2802-5.2487,3.7947-0.87376-3.754-2.5569-5.4078-4.6536-7.6786-2.0967,2.2708-3.5008,3.9245-4.3746,7.6786-0.78168-1.5145-2.9024-2.8754-5.2489-3.7946l0.00022,6.7618z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tower",
    transform: "matrix(-1,0,0,1,390.73979,0)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m72.694,694.25,245.33,0,0.00018,12.531-245.33,0.00001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.228,706.76,258.26,0,0.00018,12.512-258.26,0.00002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.576,675.51,219.56,0,0.00015,8.1093-219.56,0.00001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.157,683.56,232.4,0,0.00017,10.622-232.4,0.00001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.412,669.28,211.89,0,0.00015,6.174-211.89,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.41,669.31h16.005v49.935h-16.005z",
    strokeWidth: 1.0446
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.95,669.31h8.9171v49.936h-8.917z",
    strokeWidth: 1.0429
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.08,669.31h16.006v49.935h-16.005z",
    strokeWidth: 1.0446
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.73,669.31h8.9171v49.936h-8.917z",
    strokeWidth: 1.0429
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.19,669.31h16.005v49.935h-16.005z",
    strokeWidth: 1.0446
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.73,669.31h8.9171v49.936h-8.917z",
    strokeWidth: 1.0429
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m98.935,664.23h193.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.79,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.77,712.98h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.57,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKh);
export default __webpack_public_path__ + "static/media/kh.66413c8d34570831ab7f342dcb7f25b4.svg";
export { ForwardRef as ReactComponent };